import type { RefObject } from "react";
import type { TCurrentTime, THours, TMins } from "../../types/time_picker";
import { getCurrentTime12hr, HOURS, MINUTES } from "../../utils/timeFormatUtils";

export const PLACEHOLDER = '--:-- --';

export const DISABLED_HRS = [] as THours[];

const rotateArray = <T>(arr: T[], activeItem: T): T[] => {
  const index = arr.findIndex(item => item === activeItem);
  if (index === -1) return [...arr, ...arr, ...arr];

  const rotated = [...arr.slice(index), ...arr.slice(0, index)];
  return [...rotated, ...rotated, ...rotated];
};

export const getRotatedHours = (activeHour?: THours): THours[] => {
  return activeHour ? rotateArray([...HOURS], activeHour) : [...HOURS, ...HOURS, ...HOURS];
};

export const getRotatedMinutes = (activeMinute?: TMins): TMins[] => {
  return activeMinute ? rotateArray([...MINUTES], activeMinute) : [...MINUTES, ...MINUTES, ...MINUTES];
};

export const handleColumnScroll = (ref: RefObject<HTMLDivElement>, itemCount: number) => {
  if (!ref.current) return;

  const { scrollTop, scrollHeight, clientHeight } = ref.current;
  const itemHeight = scrollHeight / (itemCount * 3);
  const sectionHeight = itemHeight * itemCount;

  if (scrollTop <= 0) {
    ref.current.scrollTop = sectionHeight * 2 - 1;
  } else if (scrollTop >= scrollHeight - clientHeight) {
    ref.current.scrollTop = sectionHeight + 1;
  }
};

export const setInitialScrollPosition = (
  hoursRef: RefObject<HTMLDivElement>,
  minutesRef: RefObject<HTMLDivElement>
) => {
  // Start at middle section for smooth looping
  if (hoursRef.current) {
    const itemHeight = hoursRef.current.scrollHeight / (HOURS.length * 3);
    hoursRef.current.scrollTop = itemHeight * HOURS.length;
  }

  if (minutesRef.current) {
    const itemHeight = minutesRef.current.scrollHeight / (MINUTES.length * 3);
    minutesRef.current.scrollTop = itemHeight * MINUTES.length;
  }
};

export const displayTime = (currentTime: TCurrentTime) => {
  const { hour, minute, ampm } = currentTime;

  return `${hour}:${minute} ${ampm}`;
};

export const getCurrentTime = () => {
  const { hour: currentHr, minute: currentMin, ampm: currentAmPm } = getCurrentTime12hr();

  const defaultCurrentTime = {
    hour: currentHr,
    minute: currentMin,
    ampm: currentAmPm
  } as TCurrentTime;

  return defaultCurrentTime;
};